import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {navigationStates} from '../../../enums/navigationStates';
import { api as navigatorApi } from '../../AppTopbar/navigatorActions';


/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  ADMINISTRATION_RFID_SETTINGS_SELECTED_MENU_ITEM_CHANGED : 'ADMINISTRATION_RFID_SETTINGS_SELECTED_MENU_ITEM_CHANGED'
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  setSelectedMenuItemId: function(payload) {
    return {type: actionTypes.ADMINISTRATION_RFID_SETTINGS_SELECTED_MENU_ITEM_CHANGED , payload};
  }
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function(loadFirstTime) {
  return function(dispatch, getState) {
    api.init(dispatch, getState)(loadFirstTime);
  }
};

jsxActions.onSelectedMenuItemChanged  = function (selectedItemId) {
  return function(dispatch, getState) {
    dispatch(actions.setSelectedMenuItemId(selectedItemId));
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.init = function(dispatch, getState) {
  return function(loadFirstTime) {
    navigatorApi.setLoading(loadFirstTime)(dispatch, getState);

    let topNavigatorData = {
      name: createLabelHelper('mat.header.navigator.administration.').get('rfidsettings'),
      type: navigationStates.RFID_SETTINGS,
      id: 0,
      components: []
    };

    navigatorApi.setData(dispatch, getState)(topNavigatorData);
    navigatorApi.setLoading(false)(dispatch, getState);
  }
};



